import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PillSelector } from '../PillSelector';
import { useReporter } from '../../reporter';
import {
  IngredientsSection,
  IngredientsHeadline,
  IngredientsSubheadline,
  SelectorContainer,
  StyledIngredientsList,
} from './styles.js';
import { recipeIngredientsViewed } from './events';
import { RecipeIngredientsList } from './RecipeIngredientsList';

export const IngredientsList = ({ headline, subheadline, recipes }) => {
  const [selected, setSelected] = useState(recipes[0].value);
  const reporter = useReporter();
  const selectedRecipe = recipes.find(recipe => recipe.value === selected);
  const recipesChoices = recipes.map(recipe => ({
    label: recipe.label,
    value: recipe.value,
  }));

  const recipeIngredientsClicked = recipe => {
    reporter.tag(recipeIngredientsViewed(recipe));
    setSelected(recipe);
  };

  return (
    <IngredientsSection>
      <IngredientsHeadline>{headline}</IngredientsHeadline>
      <IngredientsSubheadline>{subheadline}</IngredientsSubheadline>
      <StyledIngredientsList>
        <SelectorContainer>
          <PillSelector
            choices={recipesChoices}
            onClick={recipeIngredientsClicked}
            selected={selected}
            variant="primary"
          />
        </SelectorContainer>
        <RecipeIngredientsList {...selectedRecipe} />
      </StyledIngredientsList>
    </IngredientsSection>
  );
};
IngredientsList.displayName = 'IngredientsList';

IngredientsList.propTypes = {
  headline: PropTypes.string.isRequired,
  subheadline: PropTypes.string.isRequired,
  recipes: PropTypes.array.isRequired,
};
